<bb-item-log-ui
  [records]="logRecords"
  [isPending]="true"
></bb-item-log-ui>
